import { ClearLocalStorage, getLocalStoragKey, setLocalStorage } from "../store/mahutiLocalStorage";

 export const PREFIX_PATH = process.env.PUBLIC_URL
 export const BASE_URL = process.env.REACT_APP_URL_PREFIX
 export const GETUPSALE_CALL_LIMIT = 1

 
 export const FLOW_TYPE = {
    DATE_FLOW: 'DATE_FLOW',
    ACTIVITY_FLOW: 'ACTIVITY_FLOW',
 }
 
export const API_RETRY_CALLS_NUMBER = 2;

export const VISITORS_LIMIT_ERROR_MSG = 'מספר המשתתפים לא יכול להיות יותר מ ';
export const NO_AVAILABLE_TICKETS_TODAY = 'לתאריך המבוקש אין מספיק מקומות, אנא בחרו תאריך אחר';
export const YOUR_REQUEST_IS_SAVED = ' הזמנתכם נוספה לסל הקניות ונשמרת למשך'

export const VISITORS_LIMIT_CALL_US = 'בבקשה תתקשר אלינו';

export const HERO_SUB_TEXT = '24.3 | שאול המלך 21 ת״א';

export const PAYMENT_IN_PROCESS = 'paymentInProcess';

export const PAYMENT_TIME_OUT_MINS = 5

export const GET_CAMP_ERR_MSG = 'לא נמצאו פעילויות לתאריך המבוקש';

export const PATCH_OPPORTUNITY_ERR_MSG = 'משהו השתבש, אנא נסה שוב';


export const CUSTOMER_DETAILS_DEFAULT = {
    firstName: 'AppUser',
    lastName: 'AppUSer',
    mobilePhone: '0500000000',
    email: 'dev@goodnet.org',
    companyName: 'arison',
    internal: true
}

export const LOCAL_STORAGE_TIMER = 'LOCAL_STORAGE_TIMER';
export const LOCAL_STORAGE_STEP = 'step';
export const LOCAL_STORAGE_CUSTOMER_DETAILS = 'customerDetails';

export const EVENT_IFRAME_LOAD = 'iframe-load';
export const EVENT_IFRAME_BACK = 'goBack';
export const EVENT_IFRAME_ONLOAD = 'success-page-successfully-loaded';

export const PAGES = {
    DATE_FLOW:'schedual',
    ACTIVITY_FLOW:'activity',
    PAYMENT_PAGE:'pay',
    PAYMENT_ON_SUCCESS:'paySuccess',
    PAYMENT_ON_FAILED:'payFailed'
}

export const PAGES_ARRAY = [PAGES.DATE_FLOW, PAGES.ACTIVITY_FLOW, PAGES.PAYMENT_PAGE, PAGES.PAYMENT_ON_SUCCESS, PAGES.PAYMENT_ON_FAILED]

export const STEPS = {
    DATE_SELECTION: 'dateSelection',
    ACTIVITY_SELECTION: 'activitySelection',
    TIME_SELECTION: 'timeSelection',
    FINISH: 'finish'
}

export const getCoverPhoto = (url) => {
    const coverImage = url ? 'url(' + url + ')' : undefined;
    const linear = 'linear-gradient(270.02deg, rgba(153, 28, 62, 0.76) 0.02%, rgba(240, 77, 129, 0.6688) 50.44%, rgba(159, 0, 51, 0.76) 98.86%)';
    return {background: coverImage ? linear + ', ' + coverImage + ' center' : linear}
}

export const scrollToSection = (htmlElementID) => {
    const element = document.getElementById(htmlElementID);
    element && element.scrollIntoView({ behavior: 'smooth'});
}


export const ELEMENT_LINK = {
    '#productDetailsDisplay' : 'productDetailsDisplay_view',
    '#sellingflow': 'sellingflow_view'
}

export const setStartLocalStorageTimeOut = () => {
    const nowTimeStamp = new Date();
    const timeOutLocalStorage = getLocalStoragKey(LOCAL_STORAGE_TIMER);
    if (!timeOutLocalStorage) setLocalStorage(LOCAL_STORAGE_TIMER, nowTimeStamp.getTime());
}

export const setFinishLocalStorageTimeOut = () => {
    const timeOutLocalStorage = getLocalStoragKey(LOCAL_STORAGE_TIMER);

    if (timeOutLocalStorage) {
      const now = new Date().getTime();
      const localStorageTimeOut = timeOutLocalStorage ? +timeOutLocalStorage : 0
  
      if (localStorageTimeOut && (now - localStorageTimeOut > 5 * 60 * 1000)) {
        ClearLocalStorage()
      }
  
    }
}